import { useState } from 'react'
import { toast } from 'react-toastify'
import { requestUserWalletTopUp } from '../../../../services/AccountService'

const RequestTopUpForm = ({ partnerId }) => {
  const [formData, setFormData] = useState({ amount: '', reason: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData((prev) => ({ ...prev, [id]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      await requestUserWalletTopUp(partnerId, {
        amount: formData.amount,
        reason: formData.reason,
      })
      toast.success('Top-up request submitted. An admin will review it shortly.')
      setFormData({ amount: '', reason: '' })
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to submit top-up request.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="request-top-up-form">
      <style>{`
        .request-top-up-form .form-control::placeholder {
          color: var(--bs-secondary-color, #6c757d);
          font-weight: 400;
          font-size: 0.875rem;
          opacity: 1;
        }
      `}</style>
      <div className="sell-blance mb-3">
        <label className="form-label text-muted small" htmlFor="amount">
          Amount (KES) <span className="text-danger" aria-hidden="true">*</span>
        </label>
        <div className="input-group">
          <input
            type="number"
            className="form-control"
            id="amount"
            placeholder="e.g. 5000"
            min="1"
            step="any"
            value={formData.amount}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      <div className="sell-blance mb-3">
        <label className="form-label text-muted small" htmlFor="reason">
          Reason <span className="text-danger" aria-hidden="true">*</span>
        </label>
        <textarea
          className="form-control"
          id="reason"
          rows={3}
          placeholder="Briefly describe why you need this top-up"
          value={formData.reason}
          onChange={handleChange}
          required
        />
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn btn-primary w-75"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
              Submitting…
            </>
          ) : (
            'Request Top-Up'
          )}
        </button>
      </div>
    </form>
  )
}

export default RequestTopUpForm
